import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {AuthGuard} from '../app/guards/auth.guard'

const routes: Routes = [

  {
    path: '',
    redirectTo: 'tabs',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
  },
  {
    path: 'user-info',
    loadChildren: () => import('./pages/user-info/user-info.module').then( m => m.UserInfoPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then( m => m.TabsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'orders',
    loadChildren: () => import('./pages/orders/orders.module').then( m => m.OrdersPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'cart',
    loadChildren: () => import('./pages/cart/cart.module').then( m => m.CartPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'location-modal',
    loadChildren: () => import('./modals/location-modal/location-modal.module').then( m => m.LocationModalPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'address-form',
    loadChildren: () => import('./pages/address-form/address-form.module').then( m => m.AddressFormPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'cart-modal',
    loadChildren: () => import('./modals/cart-modal/cart-modal.module').then( m => m.CartModalPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'menu-by-category',
    loadChildren: () => import('./pages/menu-by-category/menu-by-category.module').then( m => m.MenuByCategoryPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'restaurant',
    loadChildren: () => import('./pages/restaurant/restaurant.module').then( m => m.RestaurantPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'buy-anything',
    loadChildren: () => import('./pages/buy-anything/buy-anything.module').then( m => m.BuyAnythingPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'total-restaurants',
    loadChildren: () => import('./pages/total-restaurants/total-restaurants.module').then( m => m.TotalRestaurantsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'trending',
    loadChildren: () => import('./pages/trending/trending.module').then( m => m.TrendingPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then( m => m.WelcomePageModule)
  },
  {
    path: 'track-order',
    loadChildren: () => import('./pages/track-order/track-order.module').then( m => m.TrackOrderPageModule)
  },
  {
    path: 'no-service',
    loadChildren: () => import('./pages/no-service/no-service.module').then( m => m.NoServicePageModule)
  },
  {
    path: 'customer-care',
    loadChildren: () => import('./pages/customer-care/customer-care.module').then( m => m.CustomerCarePageModule)
  },
 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
